import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FontawesomeModule } from '../fontawesome/fontawesome.module';

import { HeaderNavComponent } from './header-nav/header-nav.component';

@NgModule({
  declarations: [
    HeaderNavComponent
  ],
  entryComponents: [
    HeaderNavComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FontawesomeModule
  ],
  exports: [
    HeaderNavComponent
  ]
})
export class HeaderModule { }
